export default {
  URL:
    window.location.hostname === 'exhibitionz.netlify.app'
      ? 'https://exhibition-api.1automations.com/demo'
      : 'https://exhibition-api.1automations.com/prod',
};
